import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  output,
} from '@angular/core';

import { ListActionButtonComponent } from '../list-action-button/list-action-button.component';

@Component({
  selector: 'mp-maximize-list-button',
  templateUrl: './maximize-list-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ListActionButtonComponent],
})
export class MaximizeListButtonComponent {
  readonly maximized: InputSignal<boolean> = input<boolean>(false);

  readonly toggleMaximizeList: OutputEmitterRef<void> = output<void>();

  protected readonly buttonLabel: Signal<string> = computed(() =>
    this.maximized() ? 'WENIGER ANZEIGEN' : 'ALLE ANZEIGEN',
  );
}
